<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="$t('orgManage.createOrg')"
    v-bind="$attrs"
    destroy-on-close
    :close-on-click-modal="false"
    :width="'800px'"
  >
    <div class="dialog-around h-60">
      <div class="h-full org-wrapper">
        <div class="org-create-wrapper">
          <rc-form ref="rcForm" v-bind="{ form, data: formData, formItem, showSearch: false }">
            <!-- <template #orgType>
             <el-form-item :label="$t('orgManage.orgType')" prop="orgType">
               <el-select
                v-model="formData.orgType"
                :disabled="true"
                class="w100"
                :placeholder="$t('common.pleaseChoose')"
              >
                <el-option v-for="option in manageTypeList" :key="option.dictValue" :label="option.dictLabel" :value="option.dictValue"></el-option>
              </el-select>
             </el-form-item>
          </template> -->
          </rc-form>
        </div>
      </div>
    </div>

    <span slot="footer" class="text-right">
      <el-button @click="dialogVisible = false">{{ $t('public.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('public.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import orgManageApi from "@/api/orgManage";
export default {
  name: "OrgEdit",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orgData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("userCenter.pleaseReenterPassword")));
      } else if (value !== this.formData.password) {
        callback(new Error(this.$t("userCenter.notSame")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      form: {
        labelPosition: "top",
        gutter: 20
      },
      manageTypeList: [],
      formData: {
        orgCode: "",
        orgName: "",
        orgType: "ORGANIZATION",
        orgShortName: "",
        parentId: "",
        parentName: "",
        sort: "",
        cellphone: "",
        email: "",
        username: "",
        displayName: "",
        password: "",
        rePassword: "",
        remark: ""
      },
      formItem: [
        {
          component: "rc-addon-title",
          attribute: {
            label: this.$t("public.basicInformation"),
            bar: true
          },
          span: 24,
          itemStyle: {
            marginBottom: "10px"
          }
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.orgCode"),
          placeholder: this.$t("public.pleaseEnter") + this.$t("orgManage.orgCode"),
          prop: "orgCode",
          span: 12,
          rules: [
            {
              type: "string",
              required: true,
              message: this.$t("public.pleaseEnter") + this.$t("orgManage.orgCode")
            }
          ]
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.parentOrg"),
          prop: "parentName",
          disabled: true,
          rules: [
            {
              type: "string",
              required: true,
              message: this.$t("orgManage.parentNull")
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.orgName"),
          prop: "orgName",
          placeholder: this.$t("public.pleaseEnter") + this.$t("orgManage.orgName"),
          rules: [
            {
              type: "string",
              required: true,
              message: this.$t("public.pleaseEnter") + this.$t("orgManage.orgName")
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.orgShortName"),
          prop: "orgShortName",
          placeholder: this.$t("public.pleaseEnter") + this.$t("orgManage.orgShortName"),
          span: 12
        },
        // {
        //   component: 'slot',
        //   slotName: 'orgType',
        //   span: 12
        // },
        {
          component: "rc-select",
          label: this.$t("orgManage.orgType"),
          prop: "orgType",
          disabled: true,
          span: 12,
          options: [
            {
              label: this.$t("orgManage.organization"),
              value: "ORGANIZATION"
            }
          ],
          rules: [
            {
              type: "string",
              required: true,
              message: this.$t("public.pleaseSelect") + this.$t("orgManage.orgShortName")
            }
          ]
        },
        {
          component: "rc-input-number",
          label: this.$t("public.sort"),
          prop: "sort",
          min: 0,
          step: 1,
          controlsPosition: "right",
          placeholder: this.$t("public.pleaseEnter") + this.$t("public.sort"),
          span: 12
        },
        {
          component: "rc-addon-title",
          attribute: {
            label: this.$t("orgManage.orgManager"),
            bar: true
          },
          span: 24,
          itemStyle: {
            marginBottom: "10px"
          }
        },
        {
          component: "rc-input",
          label: this.$t("userCenter.name"),
          prop: "displayName",
          placeholder: this.$t("public.pleaseEnter") + this.$t("userCenter.name"),
          rules: [
            {
              type: "string",
              required: true,
              message: this.$t("public.pleaseEnter") + this.$t("userCenter.name")
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("public.username"),
          prop: "username",
          placeholder: this.$t("public.pleaseEnter") + this.$t("public.username"),
          rules: [
            {
              type: "string",
              required: true,
              message: this.$t("public.pleaseEnter") + this.$t("public.username")
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("enterprise.phoneNumber"),
          prop: "cellphone",
          placeholder: this.$t("public.pleaseEnter") + this.$t("enterprise.phoneNumber"),
          rules: [
            {
              type: "string",
              required: false,
              min: 11,
              max: 11,
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: this.$t("public.enterCorrectPhoneNumber")
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("common.email"),
          prop: "email",
          placeholder: this.$t("public.pleaseEnter") + this.$t("common.email"),
          rules: [
            {
              type: "string",
              required: false,
              pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
              message: this.$t("public.enterCorrectEmail")
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("title.password"),
          prop: "password",
          showPassword: true,
          rules: [
            {
              required: true,
              message: this.$t("login.enterPassword")
            }
          ],
          placeholder: this.$t("public.pleaseEnter") + this.$t("title.password"),
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("enterprise.confirmPassword"),
          prop: "rePassword",
          showPassword: true,
          placeholder: this.$t("userCenter.pleaseReenterPassword"),
          rules: [
            {
              required: true,
              validator: validatePassword
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("dictInfo.description"),
          prop: "remark",
          type: "textarea",
          rows: "3",
          maxlength: 100,
          showWordLimit: true,
          placeholder: this.$t("orgManage.enterRemark"),
          span: 12
        }
      ]
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    }
  },
  async created() {
    await this.getOrgTop();
  },
  methods: {
    getOrgTop() {
      return orgManageApi.getOrgTop({}).then(res => {
        if (res.success && res.data) {
          this.$set(this.formData, "parentId", res.data.id);
          this.$set(this.formData, "parentName", res.data.orgName);
        }
      });
    },
    getFormFunction() {
      return this.$refs.rcForm.getComponentFunctionMap();
    },
    async handleSubmit() {
      const {
        orgCode,
        orgName,
        orgType,
        orgShortName,
        parentId,
        parentName,
        cellphone,
        sort,
        displayName,
        username,
        password,
        email,
        remark
      } = this.formData;
      const params = {
        orgCode,
        orgName,
        orgType,
        orgShortName,
        parentId,
        parentName,
        sort,
        remark,
        user: { cellphone, displayName, username, password, email }
      };
      orgManageApi.createOrg(params).then(res => {
        if (res.success) {
          this.$message.success(this.$t("public.create") + this.$t("common.success"));
          this.dialogVisible = false;
          this.$emit("success");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.org-create-wrapper {
  padding: 0;
  height: 100%;

  ::v-deep .router {
    &:hover {
      color: white;
    }
  }
}
</style>
